import { useEffect, useMemo, useState } from 'react';
import heroBackground from './assets/hero-devotional.png';
import mockupImage from './assets/mockup.png';
import logo from './assets/logo.png';

const CHECKOUT_URL = 'https://pay.kirvano.com/596fdef3-be8a-4a7f-8b96-acb26adf92f7';

const ICONS = {
  book: (
    <path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H20v17H8.5A3.5 3.5 0 0 0 5 22V5.5Zm3.5-.9A.9.9 0 0 0 7.6 5.5v12.4c.3-.1.6-.2.9-.2h9.9V4.6H8.5Z" />
  ),
  flame: (
    <path d="M12 22a7 7 0 0 1-7-7c0-3.1 2-5.1 4-7.1 1.3-1.3 2.6-2.7 3-4.9 2.7 1.7 4.2 4 4.2 6.6 1-.8 1.6-1.9 1.8-3.2 1.4 1.5 2 3.2 2 5.1A7.5 7.5 0 0 1 12 22Zm0-2.2a4.9 4.9 0 0 0 4.9-4.9c0-.8-.1-1.5-.4-2.2-.6.5-1.3.9-2.2 1.1.2-2.4-.3-4.3-1.5-5.8-.6 1-1.4 1.9-2.3 2.8-1.7 1.7-3.2 3.2-3.2 5.1A4.7 4.7 0 0 0 12 19.8Z" />
  ),
  compass: (
    <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Zm0-2.2a7.8 7.8 0 1 0 0-15.6 7.8 7.8 0 0 0 0 15.6Zm4.5-12.3-2.3 6.7-6.7 2.3 2.3-6.7 6.7-2.3Zm-5 4-1 2.9 2.9-1 1-2.9-2.9 1Z" />
  ),
  crown: (
    <path d="M4 18h16v2H4v-2Zm.5-12 4.3 4.2L12 4l3.2 6.2L19.5 6 18 16H6L4.5 6Zm3.2 7.8h8.6l.6-4.1-2.5 2.5-2.4-4.7-2.4 4.7-2.5-2.5.6 4.1Z" />
  ),
  shield: (
    <path d="M12 22c-4.7-1.5-8-5.8-8-10.8V4.8L12 2l8 2.8v6.4c0 5-3.3 9.3-8 10.8Zm0-2.4a9 9 0 0 0 5.8-8.4V6.4L12 4.3 6.2 6.4v4.8a9 9 0 0 0 5.8 8.4Zm-1-5.1 5-5-1.6-1.5-3.4 3.4-1.4-1.4L8 11.6l3 2.9Z" />
  ),
  bolt: (
    <path d="M13.3 2 4 13.2h7L10.7 22 20 10.8h-7L13.3 2Z" />
  ),
  card: (
    <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Zm0 4h16V7H4v2Zm0 2v6h16v-6H4Zm2 3h5v1.8H6V14Z" />
  ),
  lock: (
    <path d="M7 10V7a5 5 0 0 1 10 0v3h1.5A1.5 1.5 0 0 1 20 11.5v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5v-8A1.5 1.5 0 0 1 5.5 10H7Zm2.2 0h5.6V7a2.8 2.8 0 0 0-5.6 0v3ZM6.2 12.2v6.6h11.6v-6.6H6.2Z" />
  ),
  arrow: (
    <path d="M13.3 5.3 20 12l-6.7 6.7-1.6-1.6 4-4H4v-2.2h11.7l-4-4 1.6-1.6Z" />
  ),
  check: (
    <path d="m9.4 16.6-4-4L7 11l2.4 2.4L17 5.8l1.6 1.6-9.2 9.2Z" />
  ),
};

function renderIcon(name, className = '') {
  return (
    <svg className={`icon ${className}`} viewBox="0 0 24 24" aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

function App() {
  const [isVisible, setIsVisible] = useState({});
  const [timeLeft, setTimeLeft] = useState({ hours: 2, minutes: 47, seconds: 30 });

  const benefits = useMemo(
    () => [
      { icon: 'book', text: 'Histórias inspiradoras de gigantes da fé' },
      { icon: 'compass', text: 'Lições práticas para sua jornada espiritual' },
      { icon: 'flame', text: 'Frases fortes para reacender sua convicção' },
      { icon: 'crown', text: 'Princípios bíblicos aplicados à vida real' },
    ],
    []
  );

  const chapters = useMemo(
    () => [
      {
        icon: 'shield',
        title: 'Fé que resiste à pressão',
        text:
          'Conheça homens que permaneceram firmes em meio a oposição, dúvidas e decisões difíceis, com reflexões que conectam história, Bíblia e vida diária.',
      },
      {
        icon: 'book',
        title: 'Leitura simples, profunda e direta',
        text:
          'Um material pensado para quem quer crescer sem se perder em linguagem complicada. Ideal para devocionais, discipulado e estudos em pequenos grupos.',
      },
      {
        icon: 'compass',
        title: 'Aplicação para hoje',
        text:
          'Cada tema aponta para atitudes práticas: coragem, obediência, perseverança, serviço e compromisso real com Jesus.',
      },
      {
        icon: 'flame',
        title: 'Uma jornada de transformação',
        text:
          'Mais do que informação, o ebook conduz você a examinar a própria caminhada e fortalecer a fé com intencionalidade.',
      },
    ],
    []
  );

  const features = [
    'Acesso imediato ao ebook digital',
    'Conteúdo vitalício',
    'Atualizações gratuitas',
    'Garantia de 7 dias',
    'Bônus exclusivos da oferta',
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev.seconds > 0) return { ...prev, seconds: prev.seconds - 1 };
        if (prev.minutes > 0) return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        if (prev.hours > 0) return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.16 }
    );

    document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const redirectToKirvano = () => {
    window.location.href = CHECKOUT_URL;
  };

  return (
    <main className="app">
      <section
        id="section-hero"
        data-reveal
        className={`hero section-reveal ${isVisible['section-hero'] ? 'visible' : ''}`}
        style={{ '--hero-bg': `url(${heroBackground})` }}
      >
        <div className="hero-scrim" />

        <header className="site-header">
          <img src={logo} alt="Representante do Reino" />
          <span>Heróis da Fé</span>
        </header>

        <div className="hero-container">
          <div className="hero-content">
            <p className="eyebrow">Oferta especial por tempo limitado</p>

            <h1>
              A história dos homens que viveram pela fé pode fortalecer a sua
              caminhada hoje.
            </h1>

            <p className="hero-copy">
              Descubra ensinamentos dos grandes heróis do cristianismo em um guia
              digital direto, inspirador e aplicável para todo discípulo de Jesus.
            </p>

            <div className="benefits" aria-label="Benefícios principais">
              {benefits.map((benefit) => (
                <div key={benefit.text} className="benefit-item">
                  {renderIcon(benefit.icon)}
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>

            <button onClick={redirectToKirvano} className="btn btn-primary">
              Quero acessar o ebook
              {renderIcon('arrow')}
            </button>

            <div className="trust-badges">
              <span>Acesso imediato</span>
              <span>100% digital</span>
              <span>Garantia de 7 dias</span>
            </div>
          </div>

          <div className="book-spotlight" aria-label="Mockup do ebook Heróis da Fé">
            <div className="book-halo" />
            <img src={mockupImage} alt="Mockup do ebook Heróis da Fé" />
          </div>
        </div>
      </section>

      <section className="timer-section" aria-label="Contador da oferta">
        <p className="timer-title">Oferta expira em</p>
        <div className="timer">
          {[
            { label: 'Horas', value: timeLeft.hours },
            { label: 'Minutos', value: timeLeft.minutes },
            { label: 'Segundos', value: timeLeft.seconds },
          ].map((item) => (
            <div key={item.label} className="timer-item">
              <strong>{String(item.value).padStart(2, '0')}</strong>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section
        id="section-content"
        data-reveal
        className={`content-section section-reveal ${isVisible['section-content'] ? 'visible' : ''}`}
      >
        <div className="section-heading">
          <p className="eyebrow">O que você recebe</p>
          <h2>Um ebook para transformar inspiração em prática.</h2>
        </div>

        <div className="cards-grid">
          {chapters.map((chapter) => (
            <article key={chapter.title} className="feature-card">
              <div className="feature-icon">
                {renderIcon(chapter.icon)}
              </div>
              <h3>{chapter.title}</h3>
              <p>{chapter.text}</p>
            </article>
          ))}
        </div>

        <div className="center-action">
          <button onClick={redirectToKirvano} className="btn btn-primary">
            Começar minha transformação
            {renderIcon('arrow')}
          </button>
        </div>
      </section>

      <section
        id="section-pricing"
        data-reveal
        className={`pricing-section section-reveal ${isVisible['section-pricing'] ? 'visible' : ''}`}
      >
        <div className="pricing-layout">
          <div className="pricing-copy">
            <p className="eyebrow">50% de desconto</p>
            <h2>Entre hoje na jornada dos Heróis da Fé.</h2>
            <p>
              A oferta foi criada para facilitar seu acesso ao conteúdo completo, com
              pagamento seguro e liberação imediata após a compra.
            </p>
          </div>

          <div className="offer-panel">
            <div className="price-block">
              <span className="old-price">De R$ 19,90</span>
              <strong>R$ 9,95</strong>
              <span>ou em até 4x sem juros</span>
            </div>

            <div className="coupon-strip">
              <span>Use o cupom</span>
              <strong>REPRESENTANTEDOREINO</strong>
              <small>Cupons limitados para esta campanha.</small>
            </div>

            <div className="features-list">
              {features.map((feature) => (
                <div key={feature} className="feature-item">
                  {renderIcon('check')}
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <button onClick={redirectToKirvano} className="btn btn-success">
              {renderIcon('card')}
              Garantir minha oferta
            </button>

            <p className="secure-badge">
              {renderIcon('lock')}
              Pagamento 100% seguro
            </p>
          </div>
        </div>
      </section>

      <section className="final-cta">
        <div className="final-cta-container">
          {renderIcon('bolt', 'final-icon')}
          <h2>Pronto para fortalecer sua fé com exemplos que atravessaram gerações?</h2>
          <p>Garanta o acesso ao ebook e comece sua leitura ainda hoje.</p>
          <button onClick={redirectToKirvano} className="btn btn-light">
            Sim, quero o Heróis da Fé
            {renderIcon('arrow')}
          </button>
        </div>
      </section>

      <footer className="footer">
        <img src={logo} alt="Representante do Reino" />
        <p>
          Copyright © 2024 Representante do Reino. Todos os direitos reservados.
          Este site e seus conteúdos são protegidos por leis de direitos autorais e
          propriedade intelectual.
        </p>
      </footer>
    </main>
  );
}

export default App;
